import React from 'react'

import { Checkbox, CountryFlag } from '@fourthwall/components'

import { SelectModal } from '../SelectModal'
import * as S from './styled'
import type { SelectCountryModalViewProps } from './types'

export const SelectCountryModalView = ({
  title = 'Select countries',
  countries,
  searchInputProps,
  selectAllCheckboxProps,
  message,
  onCountrySelect,
  onConfirm,
  close,
}: SelectCountryModalViewProps) => {
  const renderCountries = () => {
    if (countries.length) {
      return countries.map((country) => (
        <S.CountryContainer htmlFor={country.key} key={country.key}>
          <Checkbox
            id={country.key}
            value={country.selected}
            onValueChange={() => onCountrySelect(country.value)}
            label={
              <S.CountryCheckboxLabel>
                <CountryFlag countryCode={country.value} size={27} />
              </S.CountryCheckboxLabel>
            }
          />
        </S.CountryContainer>
      ))
    }

    return <S.EmptyMessageContainer>No countries found</S.EmptyMessageContainer>
  }

  return (
    <SelectModal
      title={title}
      message={message}
      content={<S.CountriesContainer>{renderCountries()}</S.CountriesContainer>}
      inputProps={searchInputProps}
      selectAllCheckboxProps={selectAllCheckboxProps}
      submitButtonLabel="Confirm"
      onSubmitClick={onConfirm}
      close={close}
    />
  )
}
